"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newSlateToOld = exports.oldSlateToNew = void 0;
exports.oldSlateToNew = (v) => {
    return v.document.nodes.map((x) => {
        var _a;
        return ({
            type: x.type,
            children: [{ text: ((_a = x.nodes[0]) === null || _a === void 0 ? void 0 : _a.text) || "" }],
        });
    });
};
exports.newSlateToOld = (nodes) => {
    return {
        document: {
            nodes: nodes.map(x => {
                var _a;
                return {
                    object: "block",
                    type: x.type,
                    nodes: [{ object: "text", text: ((_a = x.children[0]) === null || _a === void 0 ? void 0 : _a.text) || "" }],
                };
            }),
        },
    };
};
//# sourceMappingURL=transformers.js.map